// T-406 — Gouvernance › Outils avancés › « Contrôle de conformité (ancien) » : l'ancien écran « Joey (Conformité) » (discussion libre, écritures gelées).
// Le nom « Joey » est désormais celui du Bureau des dossiers déposés (menu Hub Conformité › Bureau de Joey). Cet outil n'est pas supprimé.
import ComplianceAgentPage from "../../conformite/ComplianceAgentPage";

export const PHRASE_CONTROLE_CONFORMITE =
  "Ancien écran de contrôle de la conformité (discussion libre). Il est gardé pour mémoire : pour le travail de tous les jours sur les dossiers déposés, utilisez le Bureau de Joey.";

export default function GouvControleConformite({ currentTenant }) {
  return (
    <div className="space-y-4" data-testid="gouv-controle-conformite">
      <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: "var(--oh-text)" }} data-testid="gouv-controle-conformite-phrase">{PHRASE_CONTROLE_CONFORMITE}</p>
      <ComplianceAgentPage tenantId={currentTenant?.slug || "tef"} />
    </div>
  );
}
